import { VolumeIcon, VolumeOffIcon } from '@acceso/design-system';
import { useCallback, useState } from 'react';

type VolumeControlProps = {
  volume: number;
  onVolumeChange: (value: number) => void;
};
export function VolumeControl({ volume, onVolumeChange }: VolumeControlProps) {
  const [showRange, setShowRange] = useState<boolean>(false);

  const handleClick = useCallback(
    event => {
      event?.stopPropagation();
      if (volume === 0) {
        onVolumeChange?.(1);
      } else {
        onVolumeChange?.(0);
      }
    },
    [volume]
  );

  return (
    <div
      className="relative flex items-center"
      onMouseEnter={() => setShowRange(true)}
      onMouseLeave={() => setShowRange(false)}
    >
      <button onClick={handleClick} className="p-1">
        {volume > 0 ? <VolumeIcon /> : <VolumeOffIcon />}
      </button>

      {showRange && (
        <input
          type="range"
          min={0}
          max={1}
          step="0.01"
          value={volume}
          onChange={e => {
            e.stopPropagation();
            onVolumeChange(parseFloat(e.target.value));
          }}
          onMouseDown={e => e.stopPropagation()}
          onMouseUp={e => e.stopPropagation()}
          onClick={e => e.stopPropagation()}
          className="absolute bottom-[30px] left-[22px] z-50 origin-bottom-left rotate-[-90deg] cursor-pointer !accent-accent-active-primary-40"
          style={{
            transformOrigin: 'bottom left',
          }}
        />
      )}
    </div>
  );
}

export default VolumeControl;
